'use client';

import { motion, useAnimation } from 'framer-motion';
import * as React from 'react';

interface AudioLinesIconProps {
	isHovered: boolean;
}

export function AudioLinesIcon({ isHovered }: AudioLinesIconProps) {
	const controls = useAnimation();

	React.useEffect(() => {
		if (isHovered) {
			controls.start('animate');
		} else {
			controls.start('normal');
		}
	}, [isHovered, controls]);

	return (
		<div className='select-none p-2 flex items-center justify-center'>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				stroke={isHovered ? '#FF69B4' : 'currentColor'}
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			>
				<path d='M2 10v3' />
				<motion.path
					initial='normal'
					variants={{
						normal: { d: 'M6 6v11' },
						animate: {
							d: ['M6 6v11', 'M6 10v3', 'M6 6v11'],
							transition: {
								duration: 1.5,
								repeat: Infinity,
							},
						},
					}}
					animate={controls}
				/>
				<motion.path
					initial='normal'
					variants={{
						normal: { d: 'M10 3v18' },
						animate: {
							d: ['M10 3v18', 'M10 9v5', 'M10 3v18'],
							transition: {
								duration: 1,
								repeat: Infinity,
							},
						},
					}}
					animate={controls}
				/>
				<motion.path
					initial='normal'
					variants={{
						normal: { d: 'M14 8v7' },
						animate: {
							d: ['M14 8v7', 'M14 6v11', 'M14 8v7'],
							transition: {
								duration: 0.8,
								repeat: Infinity,
							},
						},
					}}
					animate={controls}
				/>
				<motion.path
					initial='normal'
					variants={{
						normal: { d: 'M18 5v13' },
						animate: {
							d: ['M18 5v13', 'M18 7v9', 'M18 5v13'],
							transition: {
								duration: 1.5,
								repeat: Infinity,
							},
						},
					}}
					animate={controls}
				/>
				<path d='M22 10v3' />
			</svg>
		</div>
	);
}
